import clsx from 'clsx';
import { NavLink } from 'react-router-dom';

import { useQueryStringParams } from '@app/hocs/query-string-params';

import FilesIcon from '@app/components/icons/files';
import { T } from '@app/components/translation';

import style from './all-documents-link.module.scss';
import { getFolderFilterValue } from '../folder-filter/folder-filter';

export const AllDocumentsLink = () => {
  const { params } = useQueryStringParams();
  const selectedFolderId = getFolderFilterValue(
    params.folderIds as
      | [
          number,
        ]
      | null,
  );

  return (
    <div className={style.AllDocumentsLinkContainer}>
      <NavLink
        className={clsx(style.AllDocumentsLink, {
          [style.Active]: selectedFolderId === null,
        })}
        to={{
          search: '',
        }}
      >
        <FilesIcon
          width="16"
          height="16"
        />
        <T
          _str="All documents"
          _comment="Link to all documents"
        />
      </NavLink>
    </div>
  );
};
